// import Button from 'components/Button/Button';
import BecomeParterForm from 'components/BecomePartnerForm/BecomePartnerForm';
import { IBecomePartnerFormValues } from 'components/BecomePartnerForm/withBecomePartnerFormState';
import Title from 'components/Title/Title';
import withContactPageQuery, {
  IWithContactPageQueryProps
} from 'enhancers/withContactPageQuery';
import withCountry from 'enhancers/withCountry';
import * as React from 'react';
import styled from 'styled-components';
import { sendContactEmail } from 'utils/sendContactEmail';
import Section from 'wrappers/Section/Section';

// import CountrySelector from 'components/CountrySelector/CountrySelector';
// import TextField from 'components/TextField/TextField';
// import Placeholder from 'react-placeholder';
type Props = IWithContactPageQueryProps;

export const BecomePartnersPage: React.SFC<Props> = props => {
  const query = props.contactQuery;
  // const background =
  //   !query.loading &&
  //   query.data &&
  //   query.data.fetch.Country.ContactPage.Background
  //     ? query.data.fetch.Country.ContactPage.Background
  //     : '#ffffff';
  // const color = getTextColor(background);

  const handleSubmit: (values: IBecomePartnerFormValues) => Promise<void> =
    !query.loading && query.data
      ? async values => {
          await sendContactEmail({
            ...values,
            message: values.country + ' ' + values.city,
            to:
              query.data &&
              query.data.fetch.Common.Partners &&
              query.data.fetch.Common.Partners.Email
                ? query.data.fetch.Common.Partners.Email
                : ''
          });
        }
      : async values => {
          // pass
        };
  return (
    <Container>
      <Section>
        <StyledTitle>F5WC Country Partner Registration</StyledTitle>
        <sup>Fields marked with an * are required</sup>
        <p>
          Want to become a regional country partner? We need to find out some
          information about you and your company. Please fill out the form below
          and we will be in contact with you shortly to get you on your way to
          hosting a regional F5WC tournament.
        </p>
        <BecomeParterForm onSubmit={handleSubmit} />
      </Section>
    </Container>
  );
};

const Container = styled.div`
  padding: 100px 20px 50px 20px;
  text-align: left;
  background-color: #381851;
  color: #fff;
`;

const StyledTitle = styled(Title)`
  margin-top: 0;
`;

// const StyledButton = styled(Button)`
//   color: #000;
// `;

export default withCountry(withContactPageQuery(BecomePartnersPage));



// WEBPACK FOOTER //
// ./src/pages/BecomePartnersPage/BecomePartnersPage.tsx